module.exports = __webpack_public_path__ + "static/media/dummy-image.812e8596.png";